export default __webpack_public_path__ + "static/media/03.8715a5d9.png";